export default __webpack_public_path__ + "static/media/imagenes certs-02.b3a7beb7.png";